import React, { useState } from 'react'
import './OTPModal.css'

export default function OTPModal({ onSubmit, error }) {
    const [otp, setOtp] = useState('')
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (otp.length !== 6) {
            alert('Please enter a 6-digit passcode')
            return
        }
        setLoading(true)
        await onSubmit(otp)
        setLoading(false)
    }

    const handleInputChange = (e) => {
        const value = e.target.value.replace(/\D/g, '').slice(0, 6)
        setOtp(value)
    }

    return (
        <div className="otp-overlay">
            <div className="otp-modal">
                <h2 className="otp-header">You have an RSVP!</h2>
                <p className="otp-message">
                    To access your invitation, please enter the 6-digit passcode that was sent to you.
                </p>

                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        value={otp}
                        onChange={handleInputChange}
                        placeholder="Enter access code"
                        className="otp-input"
                        maxLength={6}
                        autoFocus
                    />

                    {error && <p className="otp-error">{error}</p>}

                    <button
                        type="submit"
                        className="otp-submit-btn"
                        disabled={loading || otp.length !== 6}
                    >
                        {loading ? 'Verifying...' : 'Continue'}
                    </button>
                </form>

                <p className="otp-help">
                    Can't find your passcode? Please check your invitation link or contact the couple.
                </p>
            </div>
        </div>
    )
}

